import moment from "moment";
import { CopyTextToClipboard } from "../../helpers/copy";
import { FormatTimeAgo } from "../../helpers/formatTimeAgo";
import { tagsTypeBageColor } from "../../helpers/tagsBage";
import { Button, Popconfirm, Switch, Tag,  } from "antd";
import { DeleteOutlined, FormOutlined } from "@ant-design/icons";

export const ColumnsNotyfy = (
  nameMerchang,
  toggleStatus,
  handleEditRoom,
  deleteRoom,
  editRoomID,
  t,
  canEditNotify,
  canDelSetNotify,
  canOn_offNotify
) => [

    // ID
    {
      title: "#",
      key: "id",
      dataIndex: "id",
      render: (text, record, index) => <>{index + 1}</>,
      sorter: false,
    },

    // uuid
    {
      title: <span style={{ textTransform: "uppercase" }}>{t("uuid")}</span>,
      dataIndex: "uuid",
      key: "uuid",
      render: (record) => {
        return (
          <>
            <code
              className="text-truncate"
              style={{
                textWrap: "nowrap",
                maxWidth: "120px",
                color: "#3eacff",
                display: "inline-block",
                textTransform: "lowercase",
                cursor: "copy",
              }}
              onClick={() => CopyTextToClipboard(record)}
            >
              {record}
            </code>
          </>
        );
      },
    },

    // Merchant
    {
      title: t("Merchant"),
      dataIndex: "merchantID",
      key: "merchantID",
      render: (record) => {
        return (
          <>
            {nameMerchang} ({record})
          </>
        );
      },
    },

    // Chat ID
    {
      title: t("Chat ID"),
      dataIndex: "chat_id",
      key: "chat_id",
      render: (record) => {
        return (
          <>
            <code
              className="text-truncate"
              style={{
                textWrap: "nowrap",
                maxWidth: "120px",
                color: "#3eacff",
                display: "inline-block",
                textTransform: "lowercase",
                cursor: "copy",
              }}
              onClick={() => CopyTextToClipboard(record)}
            >
              {record}
            </code>
          </>
        );
      },
    },

    // Channel
    {
      title: t("Channel"),
      dataIndex: "channel",
      key: "channel",
      render: (record) => {
        return (
          <b>
            {record === "telegram" ? (
              <>
                <i
                  className="bx bxl-telegram"
                  style={{ color: "#3eacff ", fontSize: 15 }}
                ></i>{" "}
                {record}
              </>
            ) : (
              record
            )}
          </b>
        );
      },
    },

    // Type
    {
      title: t("Type"),
      dataIndex: "type_notify",
      key: "type_notify",
      render: (record) => {
        return record ? (
          <Tag color={tagsTypeBageColor(record)}>{t(record)}</Tag>
        ) : (
          <small>
            <em style={{ color: "#33333378" }}>{t("No data")}</em>
          </small>
        );
      },
    },

    // Group Name
    {
      title: t("Group Name"),
      dataIndex: "room_name",
      key: "room_name",
      render: (record) => {
        return <b>{record !== "all" ? record : "ทั่วไป"}</b>;
      },
    },

    // Status
    {
      title: t("Status"),
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <>
          <Popconfirm
            title={t(`Do you want to {{action}} notification {{room}} room?`, { action: status === 1 ? t("disable") : t("enable"), room: t(record.type_notify) })}
            onConfirm={() => canOn_offNotify ? toggleStatus(record.uuid, status) : alert(t("You don't have permission to perform this action"))}
            okText={t("Yes")}
            icon={null}

            cancelText={t("No")}
          >
            <Switch
              checked={status === 1}
              unCheckedChildren={t("disabled")}
              checkedChildren={t("enabled")}
              size="small"
            />
          </Popconfirm>
        </>
      ),
    },

    // createdAt
    {
      title: t("createdAt"),
      dataIndex: "created_at",
      key: "created_at",
      render: (record) => {
        return (
          <span title={moment(record).format("lll")}>
            {FormatTimeAgo(record)}
          </span>
        );
      },
    },

    // Action
    {
      title: t("Action"),
      key: "action",
      fixed: canEditNotify || canDelSetNotify ? "right" : false,
      render: (_, record) => {

        let btnEditRoom = (
          <Button
            loading={editRoomID === record.id}
            disabled={editRoomID === record.id}
            icon={<FormOutlined />}
            onClick={() => handleEditRoom("edit", record)}
          />
        );

        let btnDeleteRoom = (
          <Popconfirm
            title={t(`Do you want to {{action}} notification {{room}} room?`, { action: t("delete"), room: t(record.type_notify) })}
            onConfirm={() => deleteRoom(record.uuid)}
            okText={t("Yes")}
            cancelText={t("No")}
          >
            <Button icon={<DeleteOutlined />} danger style={{ marginLeft: 8 }} />
          </Popconfirm>
        );

        return <>
          {
            canEditNotify && btnEditRoom
          }
          {
            canDelSetNotify && btnDeleteRoom
          }
        </>
      },
    },
  ];
